export default __webpack_public_path__ + "static/media/elmeasure-logo.8b3c5ef1.webp";